import React, { useContext, useEffect, useRef, useState } from "react";
import FileAttach from "../../../../../../images/Attachments.svg";
import { Button } from "../../../../../../stories/Button/Button";
import { AppContext } from "../../../../../../context/context";
import {
  empType,
  Operation,
  PageFor,
} from "../../../../../../utils/Enum.types";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AtsTicketsByNodeData,
  AtsTicketsByNodeForStatus,
  GetTicketDetailsForFollowUp,
} from "../../../masters/items/queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";

import { MapsContext } from "../../context/context";
import {
  EMPTY_STRING,
  emptyMessage,
  imageFormats,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../utils/constants";
import { mapsPayloadType } from "../../context/reducer";
import { AddTicketDetails } from "../../../masters/items/queries/mutations";
import {
  AddTicketDetailsResult,
  AddTicketDetailsVariables,
} from "../../../masters/items/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { CustomModal, toIsoDate } from "../../../../../../utils/UtilFunctions";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { handleUploadAndDownloadFile } from "../../../../../../utils/Upload";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import AssignTechnician from "../../../DashBoardMapsView/dashboardcomponents/vendor/AssignTechnician";
import ResolveDetails from "../../../DashBoardMapsView/dashboardcomponents/vendor/ResolveDetails";
import { GetTickets } from "../../../../../../queries/queries";
import {
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import {
  ImageModalStylesInTickets,
  VideoPreviewModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import ImageIcon from "../../../../../../images/DownloadImage.svg";
import Close from "../../../../../../images/Close.svg";

import { Title } from "../../../../../../stories/Title/Title";
import VideoPlayer from "../../../../../common/VideoPreview";
import { GetDashboardItemAndJunctionCount } from "../../../DashBoardMapsView/dashboardcomponents/queries";

export interface StateTypes {
  vendorId: number;

  flag: boolean;
}

export interface ResolveTypes extends StateTypes {
  flag: boolean;
  vendorId: number;
  junctionId: number;
}
const AddFollowUpStatus = () => {
  const [file, setFile] = useState<FileList | null>(null);

  const [assignTechnician, setAssignTechnician] = useState<StateTypes>({
    vendorId: 0,
    flag: false,
  });
  const [imageModal, setImageModal] = useState(false);

  const [videoPreviewModal, setVideoPreviewModal] = useState(false);

  const [resolveModal, setResolveModal] = useState<ResolveTypes>({
    flag: false,
    vendorId: 0,
    junctionId: 0,
  });
  const [mutationCompleted, setMutationCompleted] = useState(false);

  const [message, setMessage] = useState(emptyMessage);
  const [remark, setRemark] = useState("");

  const [progress, setProgress] = useState(0);
  const [image, setImage] = useState("");

  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const value = useRef("");

  const [GetTicketById, { data: ticketData }] = useLazyQuery<
    AtsTicketsByNodeData,
    nodeVar
  >(AtsTicketsByNodeForStatus);

  const handleClear = () => {
    setRemark("");
    setFile(null);
    value.current = "";
    dispatch({
      type: mapsPayloadType.EMP,
      payload: {
        empId: 0,
      },
    });
  };

  const { serverDate } = useServerDateandTime();

  const [addTicket, { loading }] = useMutation<
    AddTicketDetailsResult,
    AddTicketDetailsVariables
  >(AddTicketDetails, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const { state } = useContext(AppContext);
  const { state: mapsState, dispatch } = useContext(MapsContext);

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files;
      setFile(image_as_files);
    }
  };

  useEffect(() => {
    if (mapsState.ticketId) {
      GetTicketById({
        variables: {
          id: mapsState.ticketId,
        },
      });
    }
  }, [mapsState.ticketId, GetTicketById, ticketData]);

  const handleSubmit = async (status: TicketStatus) => {
    if (
      (status === TicketStatus.RE_OPENED ||
        status === TicketStatus.RESOLVED ||
        status === TicketStatus.OPEN ||
        status === TicketStatus.ASSIGNED) &&
      !remark
    ) {
      return setMessage({
        flag: true,
        message: "Required Remarks",
        operation: Operation.NONE,
      });
    }

    setMutationCompleted(true);
    // if (
    //   status !== TicketStatus.ASSIGNED &&
    //   (file === null || (file && file[0] === undefined))
    // ) {
    //   setMessage({
    //     flag: true,
    //     message: "Attachment is required",
    //     operation: Operation.NONE,
    //   });
    //   setMutationCompleted(false);
    //   return;
    // }
    // if (
    //   (file && file[0] && status !== TicketStatus.ASSIGNED) ||
    //   status === TicketStatus.ASSIGNED
    // ) {
    const ext = file?.[0].name.split(".").pop();
    let filename = "";
    if (!ticketData) {
      setMessage({
        flag: true,
        message: "Ticket not found",
        operation: Operation.NONE,
      });
      setMutationCompleted(false);
      return;
    }
    if (status !== TicketStatus.ASSIGNED && ticketData)
      filename = file
        ? `${ticketData.node.companyID}/ticketDetails/${file?.[0].name}.${ext}`
        : "";

    if (ticketData)
      addTicket({
        variables: {
          customerID: customer_id!,
          ticketID: mapsState.ticketId,
          todaysDate: toIsoDate(serverDate),
          user_details,
          deviceTypes: [],
          input: {
            assignedID: mapsState.empId,
            status,
            remarks: remark,
            imagesPath: filename,
          },
          assetDetails: [],
        },
        refetchQueries: [
          {
            query: AtsTicketsByNodeForStatus,
            variables: {
              id: mapsState.ticketId,
            },
          },

          {
            query: GetTicketDetailsForFollowUp,
            variables: {
              customerID: customer_id!,
              ticketID: mapsState.ticketId,
            },
          },
          {
            query: GetTickets,
            variables: {
              after: null,
              first: ROWS_PER_PAGE,
              name: EMPTY_STRING,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsTicketsOrderField.TICKET_NO,
              },
              companyID: 0,
              customerID: customer_id,
              subsidiaryID: 0,
              junctionID: 0,
              reason: "",
              startDate: undefined,
              endDate: undefined,
              input: {
                itemID: 0,
                ldgrID: 0,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckSubCategoryID: 0,
                stckUomID: 0,
                query_type: TicketsQueryType.ALL,
                itemDetailsID: 0,
                status: [],
                priority: [],
                empID: user_details.id!,
              },
              siteID: 0,
            },
          },
          {
            query: GetTickets,
            variables: {
              after: null,
              first: ROWS_PER_PAGE,
              name: EMPTY_STRING,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsTicketsOrderField.TICKET_NO,
              },
              companyID: 0,
              customerID: customer_id,
              subsidiaryID: 0,
              junctionID: 0,
              reason: "",
              startDate: undefined,
              endDate: undefined,
              input: {
                itemID: 0,
                ldgrID: 0,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckSubCategoryID: 0,
                stckUomID: 0,
                query_type: TicketsQueryType.ALL,
                itemDetailsID: 0,
                status: [status],
                priority: [],
                empID: user_details.id!,
              },
              siteID: 0,
            },
          },
        ],
      }).then(async ({ data }) => {
        if (data && data.AddTicketDetails) {
          if (file && file[0] && status !== TicketStatus.ASSIGNED) {
            const ext = file[0].name.split(".").pop();
            const awsFilename = `${ticketData.node.companyID}/ticketDetails/${data.AddTicketDetails.id}_0.${ext}`;
            const uploadFilePromise = await handleUploadAndDownloadFile(
              file[0],
              awsFilename,
              setProgress,
              false
            );

            if (uploadFilePromise) {
              setFile(null);
              setMessage({
                flag: true,
                message: "Ticket updated successfully",
                operation: Operation.CREATE,
              });
              setMutationCompleted(false);
            } else {
              setMessage({
                flag: true,
                message: "File upload failed",
                operation: Operation.NONE,
              });
              setMutationCompleted(false);
            }
          } else {
            setFile(null);
            setMessage({
              flag: true,
              message: "Ticket updated successfully",
              operation: Operation.CREATE,
            });
            setMutationCompleted(false);
          }
        }
      });
    // }
  };

  const messageModalClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
  };

  if (ticketData) {
    return (
      <>
        <div className="junc-follow-up__data--flex">
          <b>Follow up status</b>
          <span>{ticketData ? ticketData.node.ticketDetails.length : 0}</span>
        </div>
        <div className="junc-follow-up__data--user-input">
          <label className="junc-follow-up__data--input">
            <input
              type="text"
              placeholder="Type here..."
              className="junc-follow-up__data--textinput"
              id="file-name-display"
              autoFocus
              onChange={(e) => {
                value.current = e.target.value;
                setRemark(e.target.value);
              }}
              value={remark}
            />

            <img
              src={FileAttach}
              alt="Attach file"
              className="browse-icon"
              onClick={() => {
                const inputFile = document.getElementById(
                  "student-documents__browse--inputTag"
                );
                if (inputFile) {
                  inputFile.click();
                }
              }}
            />
            <input
              id="student-documents__browse--inputTag"
              type="file"
              className="junc-follow-up__data--choose-file"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleImagePreview(e);
              }}
              accept="image/jpg, image/png, image/jpeg"
              required
            />
          </label>
          {/* {(data.node.status === TicketStatus.OPEN ||
            data.node.status === TicketStatus.RE_OPENED ||
            data.node.status === TicketStatus.ASSIGNED) &&
          state.empSubType === empType.VENDOR_MANAGER ? (
            <>
              <div className="row g-0">
                <div className="col-3">
                  <EmployeeSelect
                    empType={empType.TECHNICIAN}
                    onChange={(newValue) => {
                      if (newValue)
                        dispatch({
                          type: mapsPayloadType.EMP,
                          payload: {
                            empId: newValue.value,
                          },
                        });
                      else {
                        dispatch({
                          type: mapsPayloadType.EMP,
                          payload: {
                            empId: 0,
                          },
                        });
                      }
                    }}
                    onKeyDown={emptyFunc}
                    queryType={EmpQueryType.BY_TYPE}
                    ldgrId={
                      data.node.itemDetails.ldgrID
                        ? data.node.itemDetails.ldgrID
                        : data.node.vendorDetails.id
                    }
                    value={mapsState.empId}
                    label=""
                  />
                </div>
              </div>
            </>
          ) : null} */}
          {file && file.length > 0 ? (
            <>
              <img
                src={ImageIcon}
                alt=""
                className="junc-follow-up__data--remarks--flex--view"
                onClick={async () => {
                  let img = "";

                  if (file) {
                    const files = file[0].name.split(".");

                    const ext = files.length
                      ? files[files.length - 1]
                      : EMPTY_STRING;

                    try {
                      const ext = file[0].name.split(".").pop();
                      setImage(URL.createObjectURL(file[0]));
                      if (imageFormats.includes(ext!)) {
                        setImageModal(!imageModal);
                      } else setVideoPreviewModal(!videoPreviewModal);
                    } catch (err) {
                      console.error(err as Error);
                    }
                  }
                }}
              />
              {file[0].name.split("/").pop()}
              <CustomModal
                isOpen={imageModal}
                onRequestClose={() => setImageModal(!imageModal)}
                contentComponent={
                  <>
                    <div className="edit-vendor-response__title">
                      <Title>Image details</Title>
                      <img
                        src={Close}
                        alt=""
                        onClick={() => setImageModal(!imageModal)}
                      />
                    </div>
                    {image && (
                      <div
                        className={`junc-follow-up__data--remarks--flex--image-container "open" : ""
                                }`}
                      >
                        <img
                          className="junc-follow-up__data--remarks--flex--image"
                          src={image}
                          alt=""
                        />
                      </div>
                    )}
                  </>
                }
                style={ImageModalStylesInTickets}
              />
            </>
          ) : null}
          {state.empSubType === empType.VENDOR_MANAGER ||
          state.empSubType === empType.TECHNICIAN ? (
            <>
              {state.empSubType === empType.VENDOR_MANAGER &&
              (ticketData.node.status === TicketStatus.OPEN ||
                ticketData.node.status === TicketStatus.RE_OPENED ||
                ticketData.node.status === TicketStatus.ASSIGNED) ? (
                <Button
                  mode={
                    ticketData.node.status === TicketStatus.ASSIGNED
                      ? "re-assign"
                      : "assign"
                  }
                  onClick={() => {
                    setAssignTechnician({
                      flag: true,
                      vendorId: ticketData.node.itemDetails.ldgrID
                        ? ticketData.node.itemDetails.ldgrID
                        : ticketData.node.vendorDetails.id,
                    });
                  }}
                />
              ) : null}

              <Button
                mode="update"
                disabled={loading || mutationCompleted}
                onClick={() =>
                  handleSubmit(ticketData.node.status as TicketStatus)
                }
              />
              {ticketData.node.status === TicketStatus.OPEN ||
              ticketData.node.status === TicketStatus.ASSIGNED ||
              ticketData.node.status === TicketStatus.RE_OPENED ? (
                <Button
                  mode="resolve"
                  disabled={loading || mutationCompleted}
                  // onClick={() => handleSubmit(TicketStatus.RESOLVED)}
                  onClick={() =>
                    setResolveModal({
                      flag: true,
                      vendorId: ticketData.node.itemDetails.ldgrID
                        ? ticketData.node.itemDetails.ldgrID
                        : ticketData.node.vendorDetails.id,
                      junctionId: ticketData.node.junctionID
                        ? ticketData.node.junctionID
                        : 0,
                    })
                  }
                />
              ) : null}
              <Button
                mode="clear"
                disabled={loading || mutationCompleted}
                onClick={() => handleClear()}
              />
            </>
          ) : (
            <>
              {ticketData.node.status === TicketStatus.RESOLVED ? (
                <>
                  <Button
                    mode="re-open"
                    disabled={loading || mutationCompleted}
                    onClick={() => handleSubmit(TicketStatus.RE_OPENED)}
                  />
                  <Button
                    mode="close-ticket"
                    disabled={loading || mutationCompleted}
                    onClick={() => handleSubmit(TicketStatus.CLOSED)}
                  />
                </>
              ) : null}
              <Button
                mode="update"
                disabled={loading || mutationCompleted}
                onClick={() =>
                  handleSubmit(ticketData.node.status as TicketStatus)
                }
              />

              <Button
                mode="clear"
                disabled={loading || mutationCompleted}
                onClick={() => handleClear()}
              />
            </>
          )}
        </div>

        <LoadingModal flag={loading} />

        <MessageModal
          handleClose={messageModalClose}
          modalFlag={message.flag}
          operation={message.operation}
          value={message.message}
        />

        <CustomDrawer
          anchor="right"
          open={assignTechnician.flag}
          onClose={() =>
            setAssignTechnician({
              flag: false,
              vendorId: 0,
            })
          }
        >
          <AssignTechnician
            setDrawerFlag={() =>
              setAssignTechnician({
                flag: false,
                vendorId: 0,
              })
            }
            id={
              ticketData.node.itemDetails.ldgrID
                ? ticketData.node.itemDetails.ldgrID
                : ticketData.node.vendorDetails.id
            }
          />
        </CustomDrawer>

        <CustomDrawer
          anchor="right"
          open={resolveModal.flag}
          onClose={() =>
            setResolveModal({
              flag: false,
              vendorId: 0,
              junctionId: 0,
            })
          }
        >
          <ResolveDetails
            setDrawerFlag={() =>
              setResolveModal({
                flag: false,
                vendorId: 0,
                junctionId: 0,
              })
            }
            vendorId={
              ticketData.node.itemDetails.ldgrID
                ? ticketData.node.itemDetails.ldgrID
                : ticketData.node.vendorDetails.id
            }
            includeDeviceType={ticketData.node.vendorDetails.includeDeviceType}
            junctionId={
              ticketData.node.junctionID ? ticketData.node.junctionID : 0
            }
            ticketId={mapsState.ticketId}
            pageType={PageFor.GENERAL}
            companyId={ticketData.node.companyID}
          />
        </CustomDrawer>
        <CustomModal
          isOpen={videoPreviewModal}
          onRequestClose={() => setVideoPreviewModal(!videoPreviewModal)}
          contentComponent={
            <VideoPlayer
              posterSrc=""
              videoSrc={image}
              setModal={setVideoPreviewModal}
            />
          }
          style={VideoPreviewModalStyles}
        />
      </>
    );
  } else return <b className="noticketData">data not found</b>;
};

export default AddFollowUpStatus;
